<div class="container">
  @if (mediaRepository.displayUIPlayButton()) {
    <div class="button">
      <app-fa-icon class="play-icon" [config]="playIcon" />
    </div>
  }
  @if (mediaRepository.isPlaying()) {
    <div class="state">
      <app-fa-icon class="state-icon" [config]="playIcon" />
    </div>
  }
  @if (mediaRepository.isPaused()) {
    <div class="state">
      <app-fa-icon class="state-icon" [config]="pauseIcon" />
    </div>
  }
</div>
